define('sections/referrals/Podio.UI.Referrals.Signup',['require','jquery','lib/Podio.Timezone','lib/Podio.Event','lib/Podio.FormValidation'],function(require) {

  var $ = require('jquery');
  var podioTimezone = require('lib/Podio.Timezone');
  var podioEvent = require('lib/Podio.Event');
  var formValidation = require('lib/Podio.FormValidation');

  function onInit() {
    var elmForm = $('#referral_signup_box form');

    if (podioTimezone) {
      var timezone = podioTimezone.detectTimeZone().olson_tz;
      elmForm.find('input[name=timezone]').val(timezone);
    }

    formValidation.init(elmForm);
  }

  podioEvent.bind(podioEvent.Types.init, onInit);

});


